import { useContext, useEffect } from 'react';
import { FapAppContext } from '../../../context/fap-app.context';
import { appHomePage } from '../../../config/fapApp.config';
import redirectToPage from '../../../utils/redirectToPage';
import bem from '../../../utils/bem';
import SelectedContractors from '../../../Components/Molecules/SelectedContractors';
import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';

const FapEstimatePage = () => {
  const pushEvent = useAnalyticsPushEvent();
  const {
    selectedLocation: savedLocation,
    qualifications,
    agentServices,
    contractorsTray,
    setContractorsTray,
  } = useContext(FapAppContext);

  useEffect(() => {
    const estimateForm = document.querySelector(
      '.webform-submission-get-an-estimate-form',
    );

    if (estimateForm) {
      pushEvent({
        event: 'form_opened',
        event_origin: 'front_end',
        form_name: 'find_a_pro_get_estimate',
      });
    }
  }, []);

  if (!contractorsTray || !contractorsTray.length) {
    redirectToPage(appHomePage);
    return null;
  }

  const componentClassName = 'fap-estimate-page';

  const onRemoveContractorHandler = (id) => {
    const oldTray = contractorsTray;
    if (oldTray.length) {
      const newTray = oldTray.filter((i) => i.id !== id);
      setContractorsTray(newTray, agentServices, qualifications, savedLocation);
    }
  };

  return (
    <div className="container">
      <div className={bem(componentClassName)}>
        <h4 className={bem('subtitle', [], componentClassName, ['h', 'h4'])}>
          {Drupal.t(`Contractors you've selected:`)}
        </h4>
        <SelectedContractors
          contractors={contractorsTray}
          onRemove={(id) => onRemoveContractorHandler(id)}
          ctaLink={`${appHomePage}/results`}
        />
      </div>
    </div>
  );
};

export default FapEstimatePage;
